module.exports = __webpack_public_path__ + "img/20_65.36efa489.png";